/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  Loader,
  Popover,
  Text,
  TextInput
} from "@mantine/core";
import { IconCheck, IconSearch, IconX } from "@tabler/icons-react";
import React, { useEffect, useState } from "react";
import uuid from "react-uuid";
import { getTypeAhead } from "../../../services/typeAheadEndpoint";
import { FILTER_POPOVER_Z_INDEX } from "../../filter/filterStyles";

type Props = {
  value: any;
  setValue: any;
  field: string;
  workspaceID: string;
  entityType: "accounts" | "contacts";
  children?: React.ReactNode;
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  selectedValues?: any[];
  multiSelect?: boolean;
  searchValue?: any;
  setSearchValue?: any;
};

const StringDropdown = ({
  value,
  setValue,
  setSearchValue,
  searchValue,
  field,
  workspaceID,
  entityType,
  children,
  isOpen,
  setIsOpen,
  selectedValues = [],
  multiSelect = false,
}: Props) => {
  const [loaderData, setLoaderData] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [search, setSearch] = useState<string>("");

  useEffect(() => {
    const getData = async () => {
      setLoading(true);
      try {
        const temp = await getTypeAhead({
          selector_field: field,
          entity_type: entityType === "accounts" ? "accounts" : "users",
          search_query: searchValue || search || " ",
          workspace_identifier: workspaceID,
        });
        setLoaderData(
          temp?.data?.results?.map((item: any) => ({
            value: item.column_value,
            label: item.column_value,
            count: item.occurrence_count,
          })) || []
        );
      } catch (e) {
        setLoaderData([]);
      }
      setLoading(false);
    };
    if (entityType && workspaceID && field) {
      getData();
    }
  }, [value, entityType, workspaceID, field, search, searchValue]);

  return (
    <Popover
      opened={isOpen}
      onChange={setIsOpen}
      width="target"
      position="bottom"
      withArrow
      shadow="md"
      zIndex={FILTER_POPOVER_Z_INDEX}
    >
      <Popover.Target>
        <div
          className="w-full cursor-pointer"
          onClick={() => setIsOpen(true)}
        >
          {children}
        </div>
      </Popover.Target>
      <Popover.Dropdown className="rounded-lg min-w-[300px] border border-border bg-popover shadow-popover p-2">
        <div className="flex gap-3 items-center w-full flex-col">
          {multiSelect && (
            <div className="flex items-center flex-wrap gap-1 rounded-md w-full px-2 py-1 border border-border bg-muted/50">
              <TextInput
                size="xs"
                rightSection={
                  <IconSearch className="text-muted-foreground w-4 h-4" />
                }
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder="Search"
                classNames={{
                  input:
                    "bg-background text-foreground border-border text-xs",
                }}
                className="w-full"
              />
              {selectedValues.map((val) => (
                <div key={val} className="bg-background text-ellipsis overflow-hidden text-foreground border border-border rounded px-2 py-0.5 flex items-center gap-1 text-sm whitespace-nowrap">
                  <span className="text-[10px] text-ellipsis overflow-hidden line-clamp-1 max-w-[150px]">
                    {val}
                  </span>
                  <IconX
                    className="w-3 h-3 cursor-pointer text-destructive hover:text-destructive/80"
                    onClick={(e) => {
                      e.stopPropagation();
                      setValue(selectedValues.filter((item) => item !== val));
                    }}
                  />
                </div>
              ))}
            </div>
          )}
          <div
            className={`w-full flex items-center justify-between px-2 ${multiSelect ? "-my-3" : "-mb-3"
              }`}
          >
            <Text className="text-xs text-foreground font-semibold">
              {
                loaderData?.filter(
                  (item: any) => !selectedValues.includes(item.value)
                )?.length
              }{" "}
              results
            </Text>
          </div>
          <div className="flex flex-col gap-0.5 w-full bg-muted border-border border rounded-md max-h-[240px] overflow-y-auto">
            {loading ? (
              <Loader size="xs" className="mx-auto my-2" />
            ) : loaderData?.length ? (
              loaderData.map((filterItem: any) => (
                <div
                  key={uuid()}
                  onClick={(e) => {
                    if (!multiSelect) {
                      setValue(filterItem.value);
                      setSearchValue?.(filterItem.value);
                      setIsOpen(false);
                      return;
                    }
                    e.stopPropagation();
                    const isSelected = selectedValues.includes(
                      filterItem.value
                    );
                    setValue(
                      isSelected
                        ? selectedValues.filter(
                          (val) => val !== filterItem.value
                        )
                        : [...selectedValues, filterItem.value]
                    );
                  }}
                  className="px-3 py-2 w-full bg-card text-sm text-foreground hover:bg-muted cursor-pointer transition-colors duration-150 flex items-center justify-between border-b border-border last:border-b-0"
                >
                  <span>{filterItem.value}</span>
                  {selectedValues.includes(filterItem.value) && (
                    <IconCheck className="text-primary w-4 h-4" />
                  )}
                </div>
              ))
            ) : (
              <div className="px-3 py-2 text-sm text-muted-foreground italic">
                No results
              </div>
            )}
          </div>
        </div>
      </Popover.Dropdown>
    </Popover>
  );
};

export default StringDropdown;
